<div class="container-fluid">
    <h1 style="font-family: 'Acumin Variable Concept' !important;font-size: 25px;margin:5px 10px;">Notification Preferences</h1>
    <div class="sub-container">
        <div *ngIf="loading" class="wrapper">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="shadow"></div>
            <div class="shadow"></div>
            <div class="shadow"></div>
            <span>Loading</span>
        </div>
    <p *ngIf="note" style="font-size: 16px;"><b>Note:</b>To use the SMS option, please make sure your phone number is added to your profile. <a style="color: #AA004D !important;" href='./profile'>Click Here</a> to update it.</p>
        <p *ngIf="!loading"> <ag-grid-angular  
                [gridOptions]="gridOptions"
                style="width:inherit" 
                class="ag-theme-alpine"
                [rowData]="rowData"
                [pagination] ="true"
                (gridReady)="onGridReady($event)"
                [paginationPageSize]="paginationPageSize"
                [suppressExcelExport]="true"
                [columnDefs] ="columnDefs"
                [domLayout] ="domLayout"
                (rowSelected)="onRowSelected($event)"
                >
            </ag-grid-angular></p>
            <div *ngIf="!loading" style="text-align: right;"><button class="saveButton btn btn-primary" mat-button type="button" [disabled]="!changesDone" (click)="saveChanges()">Save Changes</button></div>
        </div>
    </div>